# GraphQL fragment to get basic info about a email template to display in a
# select dropdown

fragment EmailSequenceTemplateBasic on EmailSequenceTemplate {
    id
    name
    creatorUser {
        id
        name
    }
    createdTime
    emailSequenceTemplateMessages {
        id
    }
    htmlUrlPath
    hasCustomPlaceholders
}
